// Sistema de permisos granulares por usuario.
// - Roles 1/2/3 (Admin/Asesor/Produccion) = plantillas SIN restriccion: puede()=true.
// - Rol "4" (Personalizado) = gateado por user.permisos { modulo: {ver,crear,editar,eliminar} }.

// Modulos/secciones controlables. `rutas` = prefijos de ruta que pertenecen al modulo (para el guard).
export const MODULOS = [
  { key: "inicio",     label: "Monitores",  icon: "mdi mdi-gauge",              rutas: ["/inicio"] },
  { key: "clientes",   label: "Clientes",   icon: "mdi mdi-briefcase-account", rutas: ["/clientes"] },
  { key: "cotizador",  label: "Cotizador",  icon: "mdi mdi-calculator-variant",rutas: ["/cotizador", "/cotizacion-print"] },
  { key: "facturas",   label: "Facturas",   icon: "mdi mdi-cart",              rutas: ["/facturas"] },
  { key: "productos",  label: "Productos",  icon: "mdi mdi-archive",           rutas: ["/productos", "/producto"] },
  { key: "categorias", label: "Categorías", icon: "mdi mdi-shape",             rutas: ["/categorias"] },
  { key: "catalogo",   label: "Catálogo",   icon: "mdi mdi-image-multiple",    rutas: ["/catalogo"] },
  { key: "operacion",  label: "Operación",  icon: "mdi mdi-factory",           rutas: ["/operacion", "/evidencias"] },
  { key: "pedidos",    label: "Pedidos",    icon: "mdi mdi-package-variant-closed", rutas: ["/pedidos"] },
  { key: "agenda",     label: "Agenda",     icon: "mdi mdi-calendar-clock",    rutas: ["/agenda", "/prospectos", "/leads", "/cerrados"] },
  { key: "resenas",    label: "Reseñas",    icon: "mdi mdi-star-check",        rutas: ["/resenas"] },
  { key: "whatsapp",   label: "WhatsApp",   icon: "mdi mdi-whatsapp",          rutas: ["/whatsapp"] },
  { key: "usuarios",   label: "Usuarios",   icon: "mdi mdi-account-key",       rutas: ["/usuarios"] },
];

export const ACCIONES = ["ver", "crear", "editar", "eliminar"];

function todo(keys) {
  var o = {};
  keys.forEach(function (k) {
    o[k] = { ver: true, crear: true, editar: true, eliminar: true };
  });
  return o;
}

// Plantillas para PRELLENAR la matriz al elegir un rol base (no se usan como restricción
// para rol 1/2/3, que quedan sin gating).
export const PLANTILLAS = {
  // Admin: todo
  1: todo(MODULOS.map(function (m) { return m.key; })),
  // Asesor: venta + seguimiento (sin usuarios ni operación)
  2: todo(["inicio", "clientes", "cotizador", "facturas", "productos", "catalogo", "agenda", "resenas", "whatsapp"]),
  // Producción: operación / pedidos / catálogo
  3: todo(["inicio", "operacion", "pedidos", "catalogo"]),
};

// ¿El usuario tiene permisos personalizados (rol 4 / permisos definidos)?
export function esPersonalizado(user) {
  return !!(user && user.permisos && typeof user.permisos === "object" && Object.keys(user.permisos).length);
}

// Permiso puntual. Rol 1/2/3 sin permisos custom => true (no cambia nada para ellos).
export function puede(user, modulo, accion) {
  if (!user) return false;
  if (!esPersonalizado(user)) return true; // plantillas: acceso total en el front
  var m = user.permisos[modulo];
  return !!(m && m[accion]);
}

export function puedeVer(user, modulo) {
  return puede(user, modulo, "ver");
}

// Dado un path de ruta, devuelve la key del modulo al que pertenece (o null).
export function moduloDeRuta(path) {
  if (!path) return null;
  for (var i = 0; i < MODULOS.length; i++) {
    var rutas = MODULOS[i].rutas || [];
    for (var j = 0; j < rutas.length; j++) {
      var r = rutas[j];
      if (path === r || path.indexOf(r + "/") === 0) return MODULOS[i].key;
    }
  }
  return null;
}

// Primera ruta permitida para un usuario personalizado (para redirigir).
export function primeraRutaPermitida(user) {
  for (var i = 0; i < MODULOS.length; i++) {
    if (puedeVer(user, MODULOS[i].key)) {
      return (MODULOS[i].rutas && MODULOS[i].rutas[0]) || "/inicio";
    }
  }
  return "/inicio";
}
